import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const Home = () =>
    import ('../views/Home')
const Index = () =>
    import ('../views/Index')
const Exhibition = () =>
    import ('../views/ExhibitionAbout/Exhibition')
const Database = () =>
    import ('../views/DataBaseAbout/Database')
const ExhibitionSale = () =>
    import ('../views/ExhibitionSell/ExhibitionSale')
const ExhibitionSearch = () =>
    import ('../views/ExhibitionAbout/ExhibitionSearch.vue')
const Culture = () =>
    import ('../views/CultureAbout/Culture')
const ExhibitionDetail = () =>
    import ('../views/ExhibitionAbout/ExhibitionDetail')
const PaintingExhibition = () =>
    import ('../views/ExhibitionAbout/PaintingExhibition')
const ExhibitionWork = () =>
    import ('../views/ExhibitionAbout/ExhibitionWork.vue')
const ExhibitionBaseDetail = () =>
    import ('../views/ExhibitionAbout/ExhibitionBaseDetail.vue')
const ExhibitionSearchDetails = () =>
    import ('../views/ExhibitionAbout/ExhibitionSearchDetail.vue')
const ExhibitionMade = () =>
    import ('../views/ExhibitionSell/ExhibitionMade')
const ExhibitionSearchDetail = () =>
    import ('../views/ExhibitionSell/ExhibitionSearchDetail')
const ExhibitionSaleSearchDetail = () =>
    import ('../views/ExhibitionSell/ExhibitionSaleSearchDetail')
const DataBaseDetail = () =>
    import ('../views/DataBaseAbout/DataBaseDetail')
const DataBaseSearchDetail = () =>
    import ('../views/DataBaseAbout/DataBaseSearchDetail')
const DataBaseWork = () =>
    import ('../views/DataBaseAbout/DataBaseWork')
const CulturalMoreGoods = () =>
    import ('../views/CultureAbout/CulturalMoreGoods')
const CulturalGoodsDetail = () =>
    import ('../views/CultureAbout/CulturalGoodsDetail')
const CulturalCustomMade = () =>
    import ('../views/CultureAbout/CulruralCustomMade')
const CulturalCustomDetail = () =>
    import ('../views/CultureAbout/CulturalCustomDetail.vue')
const MobileDataBaseSearch = () =>
    import ('../views/MobileSearch/MobileDataBaseSearch.vue')
const MobileExhibitionSearch = () =>
    import ('../views/MobileSearch/MobileExhibitionSearch.vue')
const MobileCulturalCustomDetail = () =>
    import ('../views/MobileSearch/MobileCulturalCustomDetail.vue')
const ExhibitionWorkDetail = () =>
    import ('../views/ExhibitionAbout/ExhibitionWorkDetail.vue')
const News = () =>
    import ('../views/News/News.vue')
const NewsDetail = () =>
    import ('../views/News/NewsDetail.vue')
const About = () =>
    import ('../views/AboutUs/Index.vue')
const Inherit = () =>
    import ('../views/Inherit/Inherit.vue')
const InheritDetail = () =>
    import ('../views/Inherit/InheritDetail.vue')
const routes = [{
        path: '/',
        name: 'home',
        component: Home,
        redirect: '/index',
        children: [{
                path: '/index',
                name: 'index',
                component: Index,
                meta: {
                    title: '首页',
                    eng_title: 'Home',
                    za_title: ' ངོ་བྱང་།'
                }
            },
            {
                path: '/exhibition',
                name: 'exhibition',
                component: Exhibition,
                meta: {
                    title: '热贡作品展',
                    za_title: 'རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།',
                    eng_title: 'Regong Works Exhibition',
                },
            },
            {
                path: '/exhibitionSearchDetails',
                name: 'exhibitionSearchDetails',
                component: ExhibitionSearchDetails,
                meta: {
                    title: '热贡作品展',
                    za_title: 'རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།',
                    eng_title: 'Regong Works Exhibition',
                },
            },
            {
                path: '/database',
                name: 'database',
                component: Database,
                meta: {
                    title: '数据库',
                    za_title: 'གྲངས་མཛོད། ',
                    eng_title: 'Database',
                }
            },
            {
                path: '/exhibitionSale',
                name: 'exhibitionSale',
                component: ExhibitionSale,
                meta: {
                    title: '热贡作品展销',
                    za_title: 'རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་འཚོང་། ',
                    eng_title: 'Regong Exhibition and Sales',
                },
            },
            {
                path: '/culture',
                name: 'culture',
                component: Culture,
                meta: {
                    title: '文创设计与展销',
                    za_title: 'རིག་གཏོད་ཇུས་འགོད་དང་འགྲེམ་འཚོང་། ',
                    eng_title: 'Cultural and Creative Design Exhibition and Sales',
                }
            },
            {
                path: '/exhibitionDetail',
                name: 'exhibitionDetail',
                component: ExhibitionDetail,
                meta: {
                    title: '作品展详情',
                    eng_title: 'Details of the exhibition',
                    za_title: 'བརྩམས་ཆོས་འགྲེམ་སྟོན་གྱི་གནས་ཚུལ་ཞིབ་ཕྲ།'
                }
            },
            {
                path: '/exhibitionWork',
                name: 'exhibitionWork',
                component: ExhibitionWork,
                meta: {
                    title: '热贡作品',
                    eng_title: 'Works by Regon',
                    za_title: 'རེབ་གོང་གི་བརྩམས་ཆོས།'
                }
            },
            {
                path: '/exhibitionWorkDetail',
                name: 'exhibitionWorkDetail',
                component: ExhibitionWorkDetail,
                meta: {
                    title: '作品展详情',
                    za_title: 'བརྩམས་ཆོས་འགྲེམ་སྟོན་གྱི་གནས་ཚུལ་ཞིབ་ཕྲ།',
                    eng_title: 'Details of the exhibition',
                }
            },
            {
                path: '/paintingExhibition',
                name: 'paintingExhibition',
                component: PaintingExhibition,
                meta: {
                    title: '作品展',
                    za_title: 'བརྩམས་ཆོས་འགྲེམ་སྟོན།',
                    eng_title: 'Exhibition of works',
                }
            },
            {
                path: '/exhibitionMade',
                name: 'exhibitionMade',
                component: ExhibitionMade,
                meta: {
                    title: '作品定制',
                    za_title: 'བརྩམས་ཆོས་འདེམས་བཟོ། ',
                    eng_title: 'Customized Work',
                }
            },
            {
                path: '/exhibitionBaseDetail',
                name: 'exhibitionBaseDetail',
                component: ExhibitionBaseDetail,
                meta: {
                    title: '作品展详情',
                    za_title: 'བརྩམས་ཆོས་འགྲེམ་སྟོན་གྱི་གནས་ཚུལ་ཞིབ་ཕྲ།',
                    eng_title: 'Details of the exhibition',
                }
            },
            {
                path: '/exhibitionSearchDetail',
                name: 'exhibitionSearchDetail',
                component: ExhibitionSearchDetail,
                meta: {
                    title: '展销详情',
                    za_title: '་འགྲེམ་འཚོང་ཞིབ་གསལ།',
                    eng_title: 'Exhibition and sales details',
                }
            },
            {
                path: '/exhibitionSaleSearchDetail',
                name: 'exhibitionSaleSearchDetail',
                component: ExhibitionSaleSearchDetail,
                meta: {
                    title: '展销详情',
                    za_title: '་འགྲེམ་འཚོང་ཞིབ་གསལ།',
                    eng_title: 'Exhibition and sales details',
                }
            },
            {
                path: '/dataBaseDetail',
                name: 'dataBaseDetail',
                component: DataBaseDetail,
                meta: {
                    title: '数据库详情',
                    za_title: 'གཞི་གྲངས་མཛོད་ཀྱི་གནས་ཚུལ་ཞིབ་ཕྲ།',
                    eng_title: 'Database details',
                }
            },
            {
                path: '/dataBaseSearchDetail',
                name: 'dataBaseSearchDetail',
                component: DataBaseSearchDetail,
                meta: {
                    title: '数据库详情',
                    za_title: 'གཞི་གྲངས་མཛོད་ཀྱི་གནས་ཚུལ་ཞིབ་ཕྲ།',
                    eng_title: 'Database details',
                }
            },
            {
                path: '/dataBaseWork',
                name: 'dataBaseWork',
                component: DataBaseWork,
                meta: {
                    title: '数据库作品',
                    za_title: 'གྲངས་མཛོད་བརྩམས་ཆོས།',
                    eng_title: 'Database works',
                }
            },
            {
                path: '/culturalMoreGoods',
                name: 'culturalMoreGoods',
                component: CulturalMoreGoods,
                meta: {
                    title: '文创更多商品',
                    eng_title: 'More cultural and creative products',
                    za_title: 'རིག་གཏོད་ཚོང་རྫས་དེ་ལས་མང་བ།'
                }
            },
            {
                path: '/culturalGoodsDetail',
                name: 'culturalGoodsDetail',
                component: CulturalGoodsDetail,
                meta: {
                    title: '文创商品详情',
                    za_title: 'རིག་གཏོད་ཚོང་རྫས་ཞིབ་གསལ།',
                    eng_title: 'Details of cultural and creative products',
                }
            },
            {
                path: '/culturalCustomMade',
                name: 'culturalCustomMade',
                component: CulturalCustomMade,
                meta: {
                    title: 'AI辅助文创定制',
                    za_title: 'AIརམ་འདེགས་རིག་གཏོད་ཁྱད་བཟོ།',
                    eng_title: 'AI assisted cultural and creative customization',
                }
            },
            {
                path: '/culturalCustomDetail',
                name: 'culturalCustomDetail',
                component: CulturalCustomDetail,
                meta: {
                    title: '文创定制详情',
                    za_title: 'རིག་གཏོད་ཁྱད་བཟོའི་ཞིབ་གསལ།',
                    eng_title: 'Cultural and creative customization details',
                }
            },
            {
                path: '/inherit',
                name: 'inherit',
                component: Inherit,
                meta: {
                    title: '传承',
                    za_title: 'རྒྱུན་འཛིན།',
                    eng_title: 'Impart and inherit',
                }
            },
            {
                path: '/inheritDetail',
                name: 'inheritDetail',
                component: InheritDetail,
                meta: {
                    title: '传承人详情',
                    za_title: 'རྒྱུན་འཛིན་པའི་གནས་ཚུལ་ཞིབ་ཕྲ།',
                    eng_title: 'Inheritor details',
                }
            },
            {
                path: '/news',
                name: 'news',
                component: News,
                meta: {
                    title: '新闻动态',
                    za_title: 'གསར་འགྱུར་གྱི་གནས་ཚུལ།',
                    eng_title: 'News Updates',
                }
            },
            {
                path: '/newsDetail',
                name: 'newsDetail',
                component: NewsDetail,
                meta: {
                    title: '新闻详情',
                    za_title: 'གསར་འགྱུར་གྱི་ཞིབ་ཕྲའི་ནང་དོན། ',
                    eng_title: 'News Details',
                }
            },
            {
                path: '/about',
                name: 'about',
                component: About,
                meta: {
                    title: '关于我们',
                    za_title: 'ང་ཚོའི་སྐོར།',
                    eng_title: 'About Us',
                }
            },
        ]
    },
    {
        path: '/dataBaseSearch',
        name: 'dataBaseSearch',
        component: MobileDataBaseSearch,
        meta: {
            title: '数据库搜索',
        }
    },
    {
        path: '/exhibitionSaleSearch',
        name: 'exhibitionSaleSearch',
        component: MobileExhibitionSearch,
        meta: { title: '展销搜索' }
    },
    {
        path: '/culturalCustomSearchDetail',
        name: 'culturalCustomSearchDetail',
        component: MobileCulturalCustomDetail,
        meta: { title: '定制' }
    },
    {
        path: '/exhibitionSearch',
        name: 'exhibitionSearch',
        component: ExhibitionSearch,
        meta: {
            title: '热贡作品展',
            za_title: 'རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།',
            eng_title: 'Regong Works Exhibition',
        },
    },
];
const router = new VueRouter({
    linkActiveClass: 'tarbar',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes,
});
export default router;